import {
  DefaultNavigatorConfiguration,
  PreQualifiedCustomerNavigatorConfiguration
} from "../App/Compositions/NavigatorConfigurations";
import {
  centerSelectableBookingStepConfigurations,
  screeningStepConfigurations
} from "../App/Compositions/StepConfigurations";
import { Flow } from "./IFlow";

const noBookFlowName = "noBook";

/** The flow that a no-book guest should experience when booking an appointment. */
class NoBookFlow extends Flow {
  static readonly flowName = noBookFlowName;

  constructor(isCustomerPreQualified: boolean) {
    isCustomerPreQualified
      ? super(noBookFlowName, { ...centerSelectableBookingStepConfigurations }, [
          ...PreQualifiedCustomerNavigatorConfiguration
        ])
      : super(noBookFlowName, { ...screeningStepConfigurations, ...centerSelectableBookingStepConfigurations }, [
          ...DefaultNavigatorConfiguration
        ]);
  }
}

export default NoBookFlow;
